$(function() {
    // お気に入りボタンを押したときの処理
    var toggleMarkFail = function(btnObj,countObj,count,checked,message) {
        alert(message);    
        // カウンターを戻す
        countObj.text(count);
        // ボタンを戻す
        btnObj.prop('checked',!checked);
        return false;
    }
    var postFavoriteApi = function(btnObj) {
        // カウンター更新
        var countObj = btnObj.parents('form').find('.icn-movie-num'),
            checked  = btnObj.prop("checked"),
            count    = parseInt(countObj.text()),
            afterCount = (checked) ? count + 1 : count - 1;
        countObj.text(afterCount);

        var postData = {
            type: 'POST',
            dataType: 'json',
            processData: false,
            contentType: false,
        }
        $.ajax(btnObj.parents('form').attr('data-api-url'),postData)
            .done(function(data) { 
                if(!data.status)
                    toggleMarkFail(btnObj,countObj,count,checked,data.message); 
             })
            .fail(function() { 
                toggleMarkFail(btnObj,countObj,count,checked,"お気に入りできませんでした。"); 
            });
    }
    $('#area-shopping .favorite-button').on('change',function() { postFavoriteApi($(this)); });

    // 検索条件を変えたとき
    // カテゴリ
    $('#area-shopping-search .box-blogs-search input[name=category_all]').on('change',function() {
        $('.box-blogs-search input[name^=category').prop('checked',$(this).prop('checked'))
        $(this).parents('form').submit();
    });
    $('#area-shopping-search .box-blogs-search input[name*=category]').on('change',function() {
        if($(this).attr('name') == "category_all") return;
        $(this).parents('form').submit();
    });
    // ソート
    $('#area-shopping-search .box-blogs-search input[name*=order]').on('change',function() {
        $(this).parents('form').submit();
    });

    // カートボタン個数
    if ($('#area-shopping .box-btn-shopping-cart').length > 0) {
        $.ajax('/api/shopping/cart/count',{ dataType: 'json' })
            .done(function(data) {
                $('#area-shopping .box-btn-shopping-cart span').text(data.count);
            });
    }

    // カートに追加ボタン
    var addCartComplete = function(data) {
        if (data.status == true)
            location.href = "/shopping/cart";
        else if (data.error)
            alert(data.error);
        else
            alert('何らかのエラーでカートに追加できませんでした。');
        return false;
    }
    $('#area-shopping .link-btn-buy').on('click',function() {
        var count = $(this).parent().find('select[name=count]').val();
        var productID = $(this).attr('data-product-id');
        var formObj = new FormData();
        formObj.append('count',count);
        formObj.append('product_id',productID);
        var postData = {
            type: 'POST',
            dataType: 'json',
            data: formObj,
            processData: false,
            contentType: false,
        }
        $.ajax('/api/shopping/cart/add',postData)
            .done(addCartComplete)
            .fail(function() { alert("カートに追加できませんでした。時間を置いて再度追加してください。"); return false })
    });
    // マイページ再購入ボタン
    $('#area-pShopping .btn-rebuy').on('click',function() {
        var count = 1;
        var productID = $(this).attr('data-product-id');
        var formObj = new FormData();
        formObj.append('count',count);
        formObj.append('product_id',productID);
        var postData = {
            type: 'POST',
            dataType: 'json',
            data: formObj,
            processData: false,
            contentType: false,
        }
        $.ajax('/api/shopping/cart/add',postData)
            .done(addCartComplete)
            .fail(function() { alert("カートに追加できませんでした。時間を置いて再度追加してください。"); return false })
    });

    // カート画面 合計金額計算
    var calcCartTotal = function() {
        var total = 0;
        $.each($('ul.list-goods li'),function(i,obj) {
            if ($(this).is(':hidden')) return ;
            if ($(this).find('select').prop('disabled')) return ;
            var count = $(this).find('select').val();
            var price = $(this).attr('data-price');
            total += price * count;
        });
        $('.txt-cart-total span').text(total.toLocaleString());
        // 0円の場合は送信ボタンを非アクティブ化
        if(total == 0)
            $('.btn-submit').prop('disabled',true).addClass('btn-cancel');
        else
            $('.btn-submit').prop('disabled',false).removeClass('btn-cancel');
    }
    if ($('#area-shoppingCart .txt-cart-total').length > 0) {
        calcCartTotal();
        $('ul.list-goods li select').on('change',calcCartTotal);
    }
    // カートから削除ボタン
    $('#area-shoppingCart .btn-goods-reset').on('click',function() {
        if (!confirm('カートから商品を削除します。')) return false;

        var parentObj = $(this).parents('li');
        parentObj.find('select').prop('disabled',true);
        parentObj.hide();

        var productID = parentObj.attr('data-product-id');
        var formObj = new FormData();
        formObj.append('product_id',productID);
        var postData = {
            type: 'POST',
            dataType: 'json',
            data: formObj,
            processData: false,
            contentType: false,
        }
        $.ajax('/api/shopping/cart/delete',postData)
            .fail(function() { 
                alert("カートから削除できませんでした。時間を置いて再度削除してください。"); 
                parentObj.find('select').prop('disabled',false);
                parentObj.show();
                calcCartTotal();
                return false;
            });

        calcCartTotal();
        return false;
    });
    // 情報修正ボタン
    $('#area-shoppingCart .txt-add-back a').on('click',function() {
        var parentObj = $(this).parents('form');
        parentObj.find('input').prop('readonly',false);
        parentObj.find('select').css('pointer-events','auto');
        parentObj.find("input[name*=name1]").focus();
        $(this).hide();
    });
    // 購入ボタン制御(連打抑止)
    $('#area-shoppingConfirm button').on('click',function() {
        var formObj = $(this).parents('form'); 
        if($(this).attr('name') == "mode")
            formObj.append('<input type="hidden" name="mode" value="'+$(this).attr('value')+'" />');
        formObj.find('button').prop('disabled',true);
        formObj.submit();
    });

});

